import React from 'react';
import { useTranslation } from 'react-i18next';
import { getDotColorFromRating, sensorRating } from 'commons/src/commonFunctions';
import MaterialIcon from 'commons/src/components/MaterialIcon';
import SensorStatusDot from 'commons/src/components/sensors/SensorStatusDot';
import { sensorUnits } from 'commons/src/constants';
import { SensorTypes } from 'commons/src/models/commonEnums';
import { ReportSensorThresholds } from '../../../../models/common';

type Props = {
    value?: number;
    isAverage?: boolean;
    sensorRanges: ReportSensorThresholds;
    sensor: string;
};

const TableRowSensorStatus = (props: Props): React.ReactElement | null => {
    const {
        sensor,
        value,
        isAverage,
        sensorRanges: { ranges, unit },
    } = props;
    const { t: txt } = useTranslation();

    const valueRating = sensorRating(ranges, value);
    const displayedUnit: string =
        sensor === SensorTypes.temp ? `${sensorUnits[unit]}${(unit as string).toUpperCase()}` : sensorUnits[unit];
    if (value === undefined) {
        if (isAverage) {
            return (
                <div className="device-insight__error-response device-insight__error-response--slim">
                    <MaterialIcon extraClass="icon-color--red" name="error_outline" />
                    {txt('NoData')}
                </div>
            );
        }
        return null;
    }
    return (
        <>
            <SensorStatusDot color={getDotColorFromRating(valueRating)} />
            <span className="text-large text-bold">{parseFloat(value.toFixed(1))}</span> <span>{displayedUnit}</span>
        </>
    );
};

export default TableRowSensorStatus;
